angular.module('am4').controller('moveFacilityCtrl', function($stateParams, $state, orgFacService, orgData, facility, $scope, availableOrganizations, errorService, ngDialog) {
    this.submit = organization => {
        this.moving = true;

        return orgFacService.updateFacility(facility.id, { organization_id: organization.id })
        .then(() => {
            // Force reload the organizations & facilities dictionary
            orgFacService.refreshOrganizationsDictionary();
            orgFacService.refreshFacilitiesDictionary();

            ngDialog.closeAll();

            $state.transitionTo($state.current, angular.copy($stateParams), {
                reload: true
            });
        })
        .catch(e => {
            errorService.addError('MOVE_FACILITY_ERROR', e);
        });
    };

    const copyAvailableOrganizations = angular.copy(availableOrganizations);

    delete copyAvailableOrganizations[orgData.id];

    this.organizations = Object.keys(copyAvailableOrganizations)
    .map(function(id) {
        return {
            id: id,
            label: copyAvailableOrganizations[id]
        };
    })
    .sort(function(a, b) {
        if (a.label < b.label) { return -1; }
        if (a.label > b.label) { return 1; }
        return 0;
    });

    this.targetOrganization = this.organizations[0];

    this.initVisibleNumberUiSelectChoices = 20;
    this.visibleNumberUiSelectChoices = this.initVisibleNumberUiSelectChoices;

    $scope.$on('uiSelectInfiniteScroll:resetLimit', () => {
        this.visibleNumberUiSelectChoices = this.initVisibleNumberUiSelectChoices;
    });

    this.showMoreUiSelectChoices = () => {
        this.visibleNumberUiSelectChoices += this.initVisibleNumberUiSelectChoices;
    };
});



// WEBPACK FOOTER //
// ./src/app/controllers/moveFacilityCtrl.js